import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/mohit/Documents/Github/cp4d-managed/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Accordion mdxType="Accordion">
  <AccordionItem title="Do you provide the ability to add-on additional storage?" mdxType="AccordionItem">Yes,optional add-on parts are available for purchase.(More details - https://ibm-iacs.github.io/cp4d-managed/IACS-Offering/cloud-pak-for-data-on-aws-standalone#optional-services )  </AccordionItem>
  <AccordionItem title="What happens when the service encounters problems?" mdxType="AccordionItem">Through the managed service monitoring software our IBM operations team is automatically alerted and will begin to take action and troubleshoot the service. In addition to this, on request IBM can work with Clients to setup an email distribution list for notifications of a reduced functionality or loss of service. These types of notifications would be distributed to Clients without undue delay upon confirmation of such an issue that is known or reasonably suspected by IBM to affect the Client. IBM will provide Client with reasonably requested information about such issue and the status of any IBM remediation and restoration activities.</AccordionItem>
  <AccordionItem title="On which Cloud Service Provider is the service or application hosted? For example like AWS, Azure, GCP, etc?" mdxType="AccordionItem">This offering CPD on ROSA is based on AWS. But we have similar offering on IBM Cloud too.</AccordionItem>
  <AccordionItem title="How are the environments accessed via the network?" mdxType="AccordionItem">By default, the servers are accessible through a Client site to site VPN on the server’s public IP addresses. These public IP addresses are utilized in order avoid conflicts with Clients internal IP private subnets. Public IP’s are protected by the VPN and not accessible on the public internet. DNS resolution will be provided by default, which will be sufficient for a majority of customers. Alternatively, Client may setup access through their own internal DNS service.</AccordionItem>
  <AccordionItem title="Where can I find additional information on IBM Data Security of the Cloud Service and privacy principals?" mdxType="AccordionItem">Refer to the DSP https://www-03.ibm.com/software/sla/sladb.nsf/sla/dsp?OpenDocument</AccordionItem>
  <AccordionItem title="How do I open a support ticket?" mdxType="AccordionItem">Once the welcome letter is received Clients are entitled to log support cases, the designated Cloud Service Coordinator (CSC) will walk Clients through the registration and setup process. For reference tickets for the any of the ‘Analytics Cloud Service’ products the link is available here -> https://www.ibm.com/mysupport/s/?language=en_US.</AccordionItem>
  <AccordionItem title="What is the RTO/RPO for the managed service?" mdxType="AccordionItem">The out of the box offering allows for Seven (7) day Recovery Time Objective and (1) day / 24 hours Recovery Point Objective, optional add-on services are available for purchase to improve recovery objectives for business continuation.</AccordionItem>
    </Accordion>
    <h2>{`Other References`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/support/pages/node/6541038"
        }}>{`Managed Support Guide`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/cloud/compliance/global"
        }}>{`IBM Cloud Compliance`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www-03.ibm.com/software/sla/sladb.nsf/sla/dsp?OpenDocument"
        }}>{`IBM Data Security and Privacy Principals`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/support/customer/csol/contractexplorer/cloud/csa/us-en/10"
        }}>{`IBM Cloud Services Agreement`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/support/pages/node/6204108"
        }}>{`IBM Support Advantages`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/mysupport/s/topic/0TO50000000IYkUGAW/cloud-pak-for-data"
        }}>{`IBM Cloud Pak for data support`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      